import { getId, Icon, IRectangle, Link, List, Modal } from '@fluentui/react';
import { StyleUtils } from '../../common/views/StyleUtils';
import { Utils } from '../../common/views/Utils';
import { PopularSearchModel, PopularWebsiteModel } from '../../websites/models/PopularSearchModel';

type PopularSearchWebsiteProps = {
    search: PopularSearchModel;
    onClose: () => void;
}

export default function PopularSearchWebsiteView({ search, onClose }: PopularSearchWebsiteProps) {
    let websites = search.websites.sort((a, b) => a.name.localeCompare(b.name));

    const isMobile = window.innerWidth <= 500;
    const titleId: string = getId('title');
    const subtitleId: string = getId('subText');
    const width6 = Utils.getColumnWidth(6);

    const getItemCountForPage = (itemIndex?: number, surfaceRect?: IRectangle): number => {
        return websites.length;
    }

    const onRenderCell = (website?: PopularWebsiteModel, index?: number, isScrolling?: boolean) => {
        if (!website) {
            return <div></div>;
        }

        return <div key={website.id} className="popular-text p-10" style={{ width: '50%' }}>
            <Link href={website.url} target="_blank">
                <div className={"box pv-10 center"}>
                    {website.name}
                </div>
            </Link>
        </div>;
    }

    const searchDetailHeader = () => {
        return <div className="popup-header">
            <div className="ms-Grid ml--10 mr--10">
                <div className="ms-Grid-row bold">
                    <div className={width6}>{search.text}</div>
                    <div className={width6 + " right"}>
                        <Icon iconName="ChromeClose" className="pointer" onClick={onClose} />
                    </div>
                </div>
            </div>
        </div>;
    }

    return <>
        <Modal
            titleAriaId={titleId}
            subtitleAriaId={subtitleId}
            isOpen={true}
            onDismiss={onClose}
            isBlocking={false}
            isModeless={false}
            styles={StyleUtils.getModalWidthStyles(450)}
        >
            {searchDetailHeader()}

            <div id={subtitleId} className={(isMobile ? "mobile-" : "") + "popup-body"} style={{ display: "flow-root" }}>
                <List
                    key={search.id}
                    items={websites}
                    onRenderCell={onRenderCell}
                    getItemCountForPage={getItemCountForPage}
                />
            </div>
        </Modal>
    </>;
}